import { useContext, useEffect, useState } from "react";
import PromptCard from "../components/PromptCard";
import CreateArtworkModal from "../components/CreateArtworkModal";
import { UserContext } from "../context/UserContext";
import {
  fetchPrompts,
} from "../services/promptServices";
import "../styles/prompts.css"

function PromptsPage() {
  const [prompts, setPrompts] = useState([]);
  const [selectedPrompt, setSelectedPrompt] = useState(null)
  const { loggedInUser } = useContext(UserContext)
  
  useEffect(() => {
    const loadPrompts = async () => {
      const data = await fetchPrompts();
      setPrompts(data);
    };
    loadPrompts();
  }, []);

  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  const userToday = new Date().toLocaleDateString('en-CA', {
    timeZone: userTimezone
  })

  const usedPromptIdsToday = loggedInUser?.artworks
    ?.filter(art => {
      const localArtDate = new Date(art.created_at).toLocaleDateString('en-CA', {
    timeZone: userTimezone
      })
      return localArtDate === userToday
    })
    .map(art => art.prompt_id || [])

  const mappedPrompts = prompts?.slice(0, 2).map((prompt, index) => {
    const isUsedToday = usedPromptIdsToday?.includes(prompt.id)

    return <PromptCard 
      key={prompt.id} 
      {...prompt} 
      index={index} 
      isUsedToday={isUsedToday}
      onClick={() => setSelectedPrompt(prompt)} 
    />
})

  return (
    <div className='container'>
      <h2>Prompts</h2>
      <p>Select a prompt to continue. <strong>Materials Needed:</strong> A digital drawing app or paper with coloring tools (e.g., colored pencils or markers).</p>
      <section className="prompt-container">
        {mappedPrompts}
      </section>

      <CreateArtworkModal 
        isOpen={!!selectedPrompt} 
        onClose={() => setSelectedPrompt(null)} 
        promptId={selectedPrompt?.id} 
      />
    </div>
  );
}

export default PromptsPage;
